import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { AuthSessionService } from '../services/auth-session.service';

/**
 * Ensures that routes intended for logged-out users start only after any
 * existing client session has been torn down.
 */
export const ensureLoggedOutGuard: CanActivateFn = () => {
  return inject(AuthSessionService)
    .teardownSession({
      ignoreLogoutErrors: true,
      invalidateRefreshToken: true,
    })
    .pipe(map(() => true));
};
